import React, { useMemo } from "react";
import { TabCard } from "components/InputCards/TabCard";
import { useTranslate } from "hooks";
import { ProductImagesPreview } from "./ProductImagesPreview";
import Product3DModel, { type RequestParams } from "components/Product3DModel";
import { useProductInput } from "stores/product";
import { useProjectUnit } from "stores/project";
import { useLanguage } from "stores/globalStore";
import { Label } from "reactstrap";

// seriesId: string;
// state: ProductStateInput;
// resultUnitsSystem: string;
// languageIso2L: string;

export const ProductMediaTabs = () => {
  const productInput = useProductInput();
  const translate = useTranslate();
  const unit = useProjectUnit();
  const language = useLanguage();
  const media = useMemo(
    () => (
      <div className="mb-5 w-100 d-flex flex-column justify-content-center align-items-center">
        <Label className="py-2 mb-0 h5 fs-md w-100">
          {translate("PRODUCT_CONFIGURATOR_IMAGE")}
        </Label>
        <ProductImagesPreview disable3dButton />
      </div>
    ),
    [translate],
  );
  const productModel = useMemo(() => {
    if (productInput?.seriesId === undefined) {
      return null;
    }
    const requestParams: RequestParams = {
      seriesId: String(productInput.seriesId),
      state: productInput?.state as RequestParams["state"],
      resultUnitsSystem: unit ?? "",
      languageIso2L: language,
    };
    return (
      <div className="p-3 w-100">
        <Product3DModel requestParams={requestParams} />
      </div>
    );
  }, [productInput, unit, language]);

  return (
    <div className="m-0 w-100 bg-white">
      <TabCard
        tabs={[
          translate("PRODUCT_CONFIGURATOR_MEDIA"),
          translate("PRODUCT_CONFIGURATOR_3D"),
        ]}
        container={[media, ...(productModel ? [productModel] : [])]}
        hasNoInputProd={true}
      />
    </div>
  );
};
